import * as React from 'react';

var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgEvm = function SvgEvm(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#E3E3E3"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#333",
        d: "m59.836 24-.477 1.621v47.042l.477.476 21.836-12.907z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#8C8C8C",
        d: "M59.836 24 38 60.232l21.836 12.907V24"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#333",
        d: "m59.836 77.273-.269.329v16.757l.27.785 21.849-30.771z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#8C8C8C",
        d: "M59.836 95.144v-17.87L38 64.372z"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#141414",
        d: "m59.836 73.14 21.836-12.908-21.836-9.926z"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#383838",
        d: "m38 60.232 21.836 12.907V50.306z"
    })));
};

export { SvgEvm as ReactComponent };
//# sourceMappingURL=EVM.svg.es.js.map
